// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce-term-container {
    max-height: 250px;
    overflow-y: scroll;
    padding-right: 21px;
}

.easycommerce-term-container::-webkit-scrollbar {
	width: 5px;
    border-radius: 9999px;
}

.easycommerce-term-container::-webkit-scrollbar-track {
	background: #F0EDFB;
    border-radius: 9999px;
}

.easycommerce-term-container::-webkit-scrollbar-thumb {
	background-color: #7F7F98; 
	border-radius: 9999px;
}

.easycommerce-term-container::-webkit-scrollbar-button {
    display: none;
    height: 0;
    width: 0;
}

.easycommerce-term-container {
	scrollbar-width: auto;
}

.terms-filters-container button {
    border-radius: 4px 4px 0 0;
    border: 1px solid #7351FD;
    background-color: #00000008;
    min-width: 107px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    margin-bottom: -1px;
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #3C3C42;
}

.terms-filters-container button.active {
    border-bottom-color: white;
    background: white;
    color: #7351FD;
}

@media screen and (max-width: 1440px) {
	.terms-filters-container button {
		min-width: 65px !important;
		height: 28px !important;
		font-size: 12px !important;
	}
}
`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/pages/Products/components/Organize/style.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;CACC,UAAU;IACP,qBAAqB;AACzB;;AAEA;CACC,mBAAmB;IAChB,qBAAqB;AACzB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,QAAQ;AACZ;;AAEA;CACC,qBAAqB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,cAAc;AAClB;;AAEA;CACC;EACC,0BAA0B;EAC1B,uBAAuB;EACvB,0BAA0B;CAC3B;AACD","sourcesContent":[".easycommerce-term-container {\n    max-height: 250px;\n    overflow-y: scroll;\n    padding-right: 21px;\n}\n\n.easycommerce-term-container::-webkit-scrollbar {\n\twidth: 5px;\n    border-radius: 9999px;\n}\n\n.easycommerce-term-container::-webkit-scrollbar-track {\n\tbackground: #F0EDFB;\n    border-radius: 9999px;\n}\n\n.easycommerce-term-container::-webkit-scrollbar-thumb {\n\tbackground-color: #7F7F98; \n\tborder-radius: 9999px;\n}\n\n.easycommerce-term-container::-webkit-scrollbar-button {\n    display: none;\n    height: 0;\n    width: 0;\n}\n\n.easycommerce-term-container {\n\tscrollbar-width: auto;\n}\n\n.terms-filters-container button {\n    border-radius: 4px 4px 0 0;\n    border: 1px solid #7351FD;\n    background-color: #00000008;\n    min-width: 107px;\n    height: 34px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 16px;\n    margin-bottom: -1px;\n    font-family: Inter;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #3C3C42;\n}\n\n.terms-filters-container button.active {\n    border-bottom-color: white;\n    background: white;\n    color: #7351FD;\n}\n\n@media screen and (max-width: 1440px) {\n\t.terms-filters-container button {\n\t\tmin-width: 65px !important;\n\t\theight: 28px !important;\n\t\tfont-size: 12px !important;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
